/**
 * Engraving stock inserts picker — client-side filter + click-to-select.
 *
 * The grid is server-rendered by Bridge (GET /quick-view/engraving-stock-inserts)
 * into #engravingStockInsertBody, so this file has NO transport logic:
 *
 *  1. Filters the tiles by the `keywords` attribute Bridge stamps on each
 *     .engraving-stock-picker-item (humanized name + raw filename), same shape
 *     as quick-picker.js.
 *  2. In the engraving room, a tile (.engraving-stock-picker-select, rendered
 *     only when Bridge was given ?form=piece{ID}Medias) sets that piece's
 *     select[name=stock_id] and fires `change`, which engraving-room.js already
 *     turns into the existing preview POST (.btn-preview-stock-insert). Footer
 *     tiles are .engraving-stock-picker-zoom instead and belong to the Magnific
 *     lightbox in engraving-stock-insert-modal.liquid.
 *
 * Delegated because everything is injected into the modal after load.
 */
window.myjQuery(document).ready(function ($) {

  $('body').on('input', '.engraving-stock-picker-search', function () {

    var term = $(this).val().trim().toLowerCase();
    var $picker = $(this).closest('.engraving-stock-picker');
    var anyVisible = false;

    $picker.find('.engraving-stock-picker-item').each(function () {
      var keywords = ($(this).attr('keywords') || '').toLowerCase();
      var match = !term.length || keywords.indexOf(term) !== -1;
      $(this).toggle(match);
      if (match) {
        anyVisible = true;
      }
    });

    $picker.find('.engraving-stock-picker-noresults').toggle(!anyVisible);
  });

  $('body').on('click', '#engravingStockInsertBody .engraving-stock-picker-select', function () {

    var $select = $('form#' + $(this).data('form') + ' select[name=stock_id]');

    if (!$select.length) {
      return;
    }

    $select.val(String($(this).data('stock-id')));

    // The select carries .form-selectpicker but nothing initialises it as a
    // bootstrap-select; guard anyway so a future init keeps the button in sync.
    if ($select.data('selectpicker') && $.fn.selectpicker) {
      $select.selectpicker('refresh');
    }

    $('#engravingStockInsertModal').modal('hide');

    // engraving-room.js: change on select[name=stock_id] clicks
    // .btn-preview-stock-insert, which POSTs the form and swaps the preview.
    $select.trigger('change');
  });

});
